<template>
    <!-- 员工业绩统计－页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'recommendStatistics')">
            <div slot="header">
                <a-row>
                    <a-col :span="14">
                        <a-radio-group v-model="currentCity" @change="changeCity" class="mr8 mb8">
                            <a-radio-button class="mb8" v-for="city in cityList" :key="city.city" :value="city.city">{{city.city}}</a-radio-button>
                        </a-radio-group>
                    </a-col>
                    <a-col :span="10" class="text-right">
                        <span class="mr8 cursor-pointer" v-for="date in dateList" :key="date.value" :class="date.value == dateType ? 'text-primary' : ''" @click="changeDate(date.value)">{{date.name}}</span>
                        <a-range-picker style="width:220px" format="YYYY/MM/DD" v-model="dateRange" @change="changeDateRange" />
                        <a-button type="primary" class="ml8" @click="exportExcel">导出</a-button>
                    </a-col>
                </a-row>
            </div>
            <div class="staff">
                <a-card :bordered="false">
                    <ul class="staff-title">
                        <li v-for="item in recommendShopList" :key="item.recommendShopId" @click="changeShop(item.recommendShopId)">
                            <span class="ellipsis" :class="recommendShopId === item.recommendShopId ? 'text-primary' : ''">{{item.recommendShopName}}</span>
                            <div :class="recommendShopId === item.recommendShopId ? 'text-primary' : ''">
                                <span>¥ </span>{{(item.tradeAmount || 0).toLocaleString()}}
                            </div>
                        </li>
                    </ul>
                    <div v-show="recommendList.length > 0">
                        <div class="staff-statement">
                            <span class="font-big font-bold">业绩额报表</span>
                            <div id="mainBarAll" style="width:100%;height:380px;left:-30px"></div>
                        </div>
                        <div class="staff-sort font-big">
                            <span class="font-bold">门店业绩额排名</span>
                            <div>
                                <a-row class="mt16" v-for="(item,index) in recommendList" :key="item.recommendName">
                                    <a-col :span="4"><a-badge :count="index+1" :number-style="{backgroundColor: index < 3 ? '#333' : '#eee', color: index < 3 ? '#fff' : '#666' }"/></a-col>
                                    <a-col :span="14">{{item.recommendName}}</a-col>
                                    <a-col :span="6">{{item.recommendAmount.toLocaleString()}}</a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                    <a-empty v-if="recommendList.length == 0" />
                </a-card>
                <div class="mt24 staff-card">
                    <div>
                        <a-card :bordered="false" title="业绩明细" style="height:507px">
                            <a-button slot="extra" type="primary" class="ml8" @click="exportExcel">导出</a-button>
                            <a-table size="small" :scroll="{ y: 310 }" :bordered="false" :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                                <span slot="tradeAmount" slot-scope="tradeAmount">{{tradeAmount.toLocaleString()}}</span>
                                <a class="text-primary" slot="action" slot-scope="a,row" @click="toDetail(row.tradeNo)">订单详情</a>
                            </a-table>
                        </a-card>
                    </div>
                    <div class="staff-card-pie">
                        <a-card :bordered="false" title="票券业绩销量统计">
                            <!-- <span>* 此报表仅统计输入推荐码的票券订单销量数据，退款数据不计入其中。</span> -->
                            <div v-show="ticketRankList.length > 0" id="mainPieAll" style="width:100%;height:403px"></div>
                            <div class="sale-tab" v-show="ticketRankList.length > 0">
                                <a-row class="mt8 font-bold font-big">
                                    <a-col :span="11">票券内部标识</a-col>
                                    <a-col :span="5">销量/张</a-col>
                                    <a-col :span="8">销售额/元</a-col>
                                </a-row>
                                <div class="sale-tab-scroll">
                                    <a-row class="mt16 font-big" v-for="item in ticketRankList" :key="item.ticketTemplateId">
                                        <a-col :span="10">{{item.ticketName}}</a-col>
                                        <a-col :span="6" class="text-center">{{item.saleCount}}</a-col>
                                        <a-col :span="8">{{item.saleAmount.toLocaleString()}}</a-col>
                                    </a-row>
                                </div>
                            </div>
                            <a-empty class="mt80" style="height: 323px;" v-show="ticketRankList.length == 0" />
                        </a-card>
                    </div>
                </div>
            </div>
            <report-export-modal ref="reportExportModal" :exportType="23"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import * as echarts from 'echarts';
import { mapGetters } from "vuex";
    const columns = [
    {
        title: "姓名",
        dataIndex: "recommendName"
    },
    {
        title: "推荐号",
        dataIndex: "recommendCode"
    },
    {
        title: "订单支付时间",
        dataIndex: "payTime",
        width: 170
    },
    {
        title: "订单金额/元",
        dataIndex: "tradeAmount",
        scopedSlots: { customRender: "tradeAmount" }
    },
    {
        title: "订单状态",
        dataIndex: "tradeState",
        scopedSlots: { customRender: "tradeState" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }
    ];
export default {
    name: "staffPage",
    components: {},
    props: {},
    data() {
        return {
            columns,
            dataSource: [],
            cityList: [],
            recommendShopList: [],
            recommendShopId: undefined,
            dateList: [{value: 1,name:'今日'},{value: 2,name:'本周'},{value: 3,name:'本月'},{value: 4,name:'今年'}],
            recommendList: [],
            currentCity: undefined,
            currentDate: false,
            dateType: 3,
            dateRange: [this.$moment().startOf('month'),this.$moment().endOf('month')],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            sellAmount: 0,
            ticketRankList: [],
            myChartPie: {},
            myChartBar: {},
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    watch: {
        shopId() {
            this.getCurrentCity()
        }
    },
    methods: {
        getCurrentCity() {
            this.recommendShopId = this.shopId;
            if(this.shopId == -1) {
                this.currentCity = '全国';
                this.recommendShopList = this.cityList[0].recommendShopList;
            }else {
                this.cityList.forEach(city => {
                    city.recommendShopList.forEach(shop => {
                        if(shop.recommendShopId == this.shopId) {
                            this.currentCity = city.city;
                            this.recommendShopList = city.recommendShopList;
                        }
                    })
                })
            }
            this.getTicketRank();
            this.getRecommendRank();
            this.getRecommendDetail();
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getRecommendDetail()
        },
        /**
         * @toDetail 查看订单详情
         */
        toDetail(orderId) {
            this.$router.push({name: 'buyOrder', params: {orderId}});
        },
        /**
         * @func openExportModal 打开导出记录弹窗
         */
        openExportModal() {
            this.$refs.reportExportModal.open();
        },
        changeCity(e) {
            this.recommendShopList = this.cityList.filter(item => {return e.target.value === item.city})[0].recommendShopList;
            this.recommendShopId = this.recommendShopList[0].recommendShopId;
            this.getTicketRank();
            this.getRecommendRank();
            this.getRecommendDetail();
        },
        changeShop(e) {
            this.recommendShopId = e;
            this.getTicketRank();
            this.getRecommendRank();
            this.getRecommendDetail();
        },
        changeDate(value) {
            this.dateType = value;
            switch(value) {
                case 1: 
                    this.dateRange = [this.$moment(),this.$moment()];
                    break;
                case 2: 
                    this.dateRange = [this.$moment().startOf('week'),this.$moment().endOf('week')];
                    break;
                case 3: 
                    this.dateRange = [this.$moment().startOf('month'),this.$moment().endOf('month')];
                    break;
                case 4: 
                    this.dateRange = [this.$moment().startOf('year'),this.$moment().endOf('year')];
                    break;
                default:
                break;
            }
            this.getStatisticsShop();
        },
        changeDateRange(e) {
            this.dateType = 5;
            this.dateRange = e;
            this.getStatisticsShop();
        },
        getValues() {
            let shopIds = [];
            this.recommendShopId && shopIds.push(this.recommendShopId);
            let obj = {
                pageNum: 1,
                pageSize: 99999,
                dateType: this.dateType,
                startDate: this.dateType == 5 ? this.dateRange[0].format('YYYY-MM-DD') : undefined,
                endDate: this.dateType == 5 ? this.dateRange[1].format('YYYY-MM-DD') : undefined,
                shopIds: shopIds.join(','),
            }
            return obj
        },
        getStatisticsShop() {
            this.$api.statement.statisticsShop({
                query: this.getValues()
            })
            .then(res => {
                this.cityList = res;
                // if(!this.currentCity) {
                //     this.currentCity = res[0].city;
                //     this.recommendShopList = res[0].recommendShopList;
                //     this.recommendShopId = res[0].recommendShopList[0].recommendShopId;
                // }else {
                //     this.recommendShopList = res.filter(item => item.city === this.currentCity)[0].recommendShopList;
                // }
                this.getCurrentCity()
                // this.getTicketRank();
                // this.getRecommendRank();
                // this.getRecommendDetail();
            })
            .catch(err => {
                
            })
        },
        getTicketRank() {
            this.$api.statement.ticketRank({
                query: this.getValues()
            })
            .then(res => {
                this.ticketRankList = res;
                this.sellAmount = 0;
                let data = [];
                res.forEach(item => {
                    data.push({
                        name: item.ticketName,
                        value: item.saleCount,
                    })
                    this.sellAmount += item.saleAmount;
                })
                setTimeout(() => {
                    this.initPie(data);
                    this.myChartPie.resize();
                },200)
            })
            .catch(err => {
                this.loading = false;
            })
        },
        getRecommendRank() {
            this.$api.statement.recommendRank({
                query: this.getValues()
            })
            .then(res => {
                this.recommendList = res;
                let dataX = []
                let dataY = []
                // res = res.concat(res).concat(res)
                for(let item of res) {
                    // 每3个字插入换行符
                    dataX.push(item.recommendName && item.recommendName.match(/(.{3})|(.{2})|(.)/g).join('\n'))
                    dataY.push(item.recommendAmount)
                }
                setTimeout(() => {
                    this.initBar(dataX,dataY)
                    this.myChartBar.resize();
                },200)
            })
            .catch(err => {
                
            })
        },
        getRecommendDetail() {
            this.$api.statement.recommendDetail({
                query: this.getValues()
            })
            .then(res => {
                this.dataSource = res.list;
            })
            .catch(err => {
                
            })
        },
        initBar(dataX,dataY) {
            let myChartBar = echarts.init(document.getElementById('mainBarAll'),'light');
            myChartBar.setOption({
                xAxis: {
                    // name: '门店',
                    type: 'category',
                    data: dataX,
                    axisLine: {
                        lineStyle: {
                            color: 'rgba(0, 0, 0, 0.45)'  // 设置X轴坐标轴的颜色
                        },
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                },
                yAxis: {
                    // name: '金额/元',
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} '
                    },
                    axisLine: {
                        show: false,  // 隐藏纵坐标的刻度线
                        lineStyle: {
                            color: 'rgba(0, 0, 0, 0.45)'  // 设置X轴坐标轴的颜色
                        }
                    },
                    axisTick: {
                        show: false, // 隐藏纵坐标的刻度值
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'   // 设置分割线的类型为虚线
                        }
                    },
                },
                tooltip: {
                    trigger: 'axis',
                },
                dataZoom: [{
                    type: 'slider',
                    show: dataX.length > 20,
                    start: 0,
                    end: 100,
                }],
                series: [{
                    type:'bar',
                    barWidth: '26',
                    barGap: 5,
                    barCategoryGap:5,
                    data: dataY,
                    label:{
                        normal:{
                            color: '#333',
                            show: true,            //显示数字
                            position: 'top'        //这里可以自己选择位置
                        }
                    },
                    
                }],
                color: '#1890FF',
            })
            this.myChartBar = myChartBar;
        },
        initPie(data) {
            let _this = this
            let myChartPie = echarts.init(document.getElementById('mainPieAll'),'light');
            myChartPie.setOption({
                title: {
                    show: true,
                    text: '销售额（元）',
                    subtext: _this.sellAmount.toLocaleString(),
                    textAlign: 'center',
                    top: '44%',
                    left: '25%',
                    textStyle: {
                        fontSize: '12',
                        fontWeight: '400',
                        color: '#999'
                    },
                    subtextStyle: {
                        fontSize: '22',
                        fontWeight: '900',
                        color: '#333'
                    },
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    left: 300,
                    top: 56,
                    bottom: 24,
                    selectedMode: false,
                    show: false
                },
                series: [{
                    name: '票券销量/张',
                    radius : '50%',
                    type: 'pie',
                    center: ['25%','50%'],
                    radius: ['50%', '70%'],
                    data: data,
                    label: {
                        normal: {
                            show: false,
                            position: 'center'
                        },
                    },
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 5,
                    }
                }],
            })
            this.myChartPie = myChartPie;
        },
        // 导出excel
        exportExcel() {
            let shopIds = [];
            this.recommendShopId && shopIds.push(this.recommendShopId);
            this.$api.statement.staffExport({
                query: {
                    pageNum: 1,
                    pageSize: 999999,
                    startDate: this.dateRange[0].format('YYYY-MM-DD'),
                    endDate: this.dateRange[1].format('YYYY-MM-DD'),
                    shopIds: shopIds.join(',')
                }
            }).then(res => {
                this.openExportModal();
                // this.loading = false;

            }).catch(err => {
                // this.loading = false;
            });
        },
    },
    beforeCreate() {},
    created() {},
    mounted() {
        this.getStatisticsShop()
        window.onresize = ()=> {
            if(this.$route.name === 'recommendStatistics') {
                this.myChartBar.resize();
                this.myChartPie.resize();
            }
        }
    }
};
</script>
<style lang="scss">
    .staff {
        .ant-table-small {
            border: none;
        }

        &-title {
            display: -webkit-box;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: nowrap;
            width: 100%;
            overflow-x: auto;
            margin-bottom: 24px;
            border-radius: 3px;
            background-color: #fff;
            >li {
                margin: 24px 0 16px;
                padding: 0 16px;
                border-left: 1px solid #E8E8E8;
                text-align: center;
                &:hover {
                    cursor: pointer;
                }
                >span {
                    color: rgba(0,0,0,.45);
                }
                >div {
                    font-size: 24px;
                }
            }
            >li:first-child {
                border: 0;
            }
            >li:last-child {
                padding-right: 24px;
            }
        }
        &-statement {
            float: left;
            width: calc(100% - 240px);
        }
        &-sort {
            width: 240px;
            float: left;
            >div {
                height: 360px;
                overflow-y: scroll;
                &::-webkit-scrollbar { width: 0 !important }
            }
        }
        &-card {
            display: flex;
            justify-content: space-between;
            >div {
                width: calc(50% - 12px);
            }
            &-pie {
                position: relative;
                .sale-tab {
                    position: absolute;
                    right: -10px;
                    top: 120px;
                    width: 300px;
                    .sale-tab-scroll {
                        height: 320px;
                        overflow-y: scroll;
                        &::-webkit-scrollbar { width: 0 !important }
                    }
                }
            }
        }
    }
</style>